"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IO = void 0;
const player_1 = require("../modules/shared/player");
const types_1 = require("../sync/types");
const async_1 = require("../utils/async");
class IO {
    constructor(roomId, socket) {
        this.roomId = roomId;
        this.socket = socket;
        this.abort = false; // abort link
        this.callbackCache = new Map();
    }
    waitToConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.abort = false;
            while (!this.socket.connected) {
                console.log(`waiting for ${this.roomId} socket connection...`);
                if (this.abort) {
                    console.error('Connection cancelled: ', this.roomId);
                    return false;
                }
                yield (0, async_1.wait)(500);
            }
            return true;
        });
    }
    watch(roomId, shareId, embedId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.waitToConnect();
            return new Promise((resolve, reject) => {
                if (!this.socket.connected) {
                    resolve();
                    return;
                }
                let retryTimes = 3;
                const emit = (interval) => {
                    this.socket.emit(types_1.SyncRequestTypes.WATCH_ROOM, Object.assign(Object.assign({}, params), { roomId, shareId, embedLinkId: embedId }), (msg) => {
                        interval && clearInterval(interval);
                        if ('success' in msg && msg.success) {
                            console.log('watched in ', roomId, this.socket.id, 'msg:', msg);
                            resolve(msg);
                        }
                        else {
                            player_1.Player.doTrigger(player_1.Events.app_error_logger, {
                                error: new Error(`watchRoom failed: ${msg.message}`),
                                metaData: {
                                    socketConnected: this.socket.connected
                                },
                            });
                            reject(msg);
                        }
                    });
                };
                const interval = setInterval(() => {
                    if (retryTimes < 0) {
                        clearInterval(interval);
                        reject('The link with the server has not been established successfully, please refresh and try again. \
                  If you have any questions, please scan the QR code on the right to add customer service, and let us help you solve');
                    }
                    retryTimes--;
                    emit(interval);
                }, 5 * 1000);
                emit(interval);
            });
        });
    }
    request(params) {
        if (!this.socket) {
            throw new Error('socket didn\'t prepared');
        }
        // console.log('Send data:', params);
        return new Promise((resolve) => {
            this.socket.emit(params.type, params, (responseData) => {
                resolve(responseData);
            });
        });
    }
    unWatch() {
        this.abort = true;
        return new Promise((resolve) => {
            this.socket.emit(types_1.SyncRequestTypes.LEAVE_ROOM, { roomId: this.roomId }, (msg) => {
                console.log('unwatch: ', this.roomId, 'msg:', msg);
                this.offAll();
                resolve(msg);
            });
        });
    }
    offAll() {
        this.callbackCache.forEach((cb, name) => {
            this.socket.off(name, cb);
        });
        this.callbackCache.clear();
    }
    on(name, cb) {
        if (this.callbackCache.has(name)) {
            throw new Error(`Do not bind socket events repeatedly: ${name}`);
        }
        this.callbackCache.set(name, cb);
        this.socket.on(name, cb);
    }
}
exports.IO = IO;
//# sourceMappingURL=io.js.map